import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/Index.vue";

import About from "../views/docs/About.vue";
import Layout from "../components/Layout.vue";
import Info from "../views/token/Info.vue";
import Login from "../views/login/Login.vue";
import Register from "../views/login/Register.vue";
import ResetPassword from "../views/login/ResetPassword.vue";
import Member from "../views/member/Member.vue";
import Setting from "../views/member/Setting.vue";
import Rental from "../views/rental/Index.vue";
import RentalDetail from "../views/rental/Detail.vue";
import Verify from "../views/login/Verify.vue";
import Error from "../views/Error.vue";
import Deposit from "../views/wallet/Deposit.vue";
import Withdraw from "../views/wallet/Withdraw.vue";
import BindAddress from "../views/wallet/BindAddress.vue";
import Agreement from "../views/docs/Agreement.vue";

Vue.use(VueRouter);

import consts from "@/utils/consts.js";
const routes = [
  {
    path: "/",
    name: "Layout",
    component: Layout,
    meta: { IsLogin: true },
    children: [
      {
        path: "/",
        name: "Index",
        component: Index,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/info",
        name: "Info",
        component: Info,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/rental",
        name: "Rental",
        component: Rental,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/rental/detail",
        name: "RentalDetail",
        component: RentalDetail,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/about",
        name: "About",
        component: About,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/member",
        name: "Member",
        component: Member,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/setting",
        name: "Setting",
        component: Setting,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/deposit",
        name: "Deposit",
        component: Deposit,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/withdraw",
        name: "Withdraw",
        component: Withdraw,
        meta: { IsLogin: true }, // 需要登录
      },
      {
        path: "/bind-address",
        name: "BindAddress",
        component: BindAddress,
        meta: { IsLogin: true }, // 需要登录
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { IsLogin: false }, // 不需要登录
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { IsLogin: false }, // 不需要登录
  },
  {
    path: "/verify",
    name: "Verify",
    component: Verify,
    meta: { IsLogin: false }, // 不需要登录
  },
  {
    path: "/error",
    name: "Error",
    component: Error,
    meta: { IsLogin: false }, // 不需要登录
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { IsLogin: false }, // 不需要登录
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: Agreement,
    meta: { IsLogin: false }, // 需要登录
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    to;
    from;
    savedPosition;
    return { x: 0, y: 0 };
  },
});

// 路由守卫 - 检测登录状态
router.beforeEach((to, from, next) => {
  // 检查该路由是否需要登录
  if (to.matched.some((record) => record.meta.IsLogin)) {
    // 判断是否登录 - 从 localStorage 或 Vuex 中获取 token

    const token =
      localStorage.getItem(consts.KEY_TOKEN) ||
      sessionStorage.getItem(consts.KEY_TOKEN);

    if (token) {
      // 已登录，允许访问
      next();
    } else {
      // 未登录，跳转到登录页面，并携带目标路径
      next({
        path: "/login",
        query: { redirect: to.fullPath }, // 登录后可以跳转回来
      });
    }
  } else {
    // 不需要登录的页面直接访问
    next();
  }
});

export default router;
